
class SuiteConfig {
    evento:number = 299;
    token:string = 'YXBpOmFwaSQyMjI6MjAyMzEzMzJfMDUzMjU3';
}

export default new SuiteConfig();
